require('./src/angular-local-storage.js');
module.exports = 'LocalStorageModule';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-local-storage/index.js
 ** module id = 16
 ** module chunks = 0
 **/